module.exports = __webpack_public_path__ + "static/8-a053b1030f06f6c3c36618ac9a14ec0a.jpg";